import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import {
  AddMailListRequest,
  EditMailListRequest,
  MailListRequest,
  MailListResponse,
  ModifyMailListResponse,
  ToggleMailListRequest,
} from './mail-list-api.def.ts'

const interfaceName = 'mail-list'

export const mailListApi = createApi({
  reducerPath: 'mailListApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['mail-list'],
  endpoints: (build) => ({
    listMailEntries: build.query<MailListResponse, MailListRequest>({
      query: (params) => ({
        url: '/list',
        method: 'GET',
        params: params,
      }),
      providesTags: ['mail-list'],
    }),
    addMailEntry: build.mutation<ModifyMailListResponse, AddMailListRequest>({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['mail-list'],
    }),
    editMailEntry: build.mutation<ModifyMailListResponse, EditMailListRequest>({
      query: ({ id, listType }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: { listType },
      }),
      invalidatesTags: ['mail-list'],
    }),
    toggleMailEntry: build.mutation<
      ModifyMailListResponse,
      ToggleMailListRequest
    >({
      query: (payload) => ({
        url: '/toggle',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['mail-list'],
    }),
  }),
})

export const {
  useListMailEntriesQuery,
  useLazyListMailEntriesQuery,
  useAddMailEntryMutation,
  useEditMailEntryMutation,
  useToggleMailEntryMutation,
} = mailListApi
